import loadable from "@loadable/component";
import { ErrorBoundary } from "../../components";
import FullPageLoader from "@Components/FullPageLoader";

const AsyncGroupBookingV2 = loadable(() => import("./GroupBookingV2"), {
  fallback: <FullPageLoader />,
});

export default (props: any): JSX.Element => (
  <ErrorBoundary>
    <AsyncGroupBookingV2 {...props} />
  </ErrorBoundary>
);
